import { createContext } from 'react';
import { FormContextValue } from './types';

export default createContext<FormContextValue>(null);
